"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Read-only display cards for the Concur report WRITE tools. They show what is
 * being created or changed; nothing on them is actionable.
 */
export const concurReportWriteToolRegistry = {
  concurCreateReport: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./report-write-views").then(({ ConcurCreateReportToolView }) => ({
        default: ConcurCreateReportToolView,
      }))
    ),
  },
  concurUpdateReport: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./report-write-views").then(({ ConcurUpdateReportToolView }) => ({
        default: ConcurUpdateReportToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
